// Delad hjälpfunktion för att visa projekt på ett sätt som användare känner igen.
//
// Användare refererar ALLTID till projektnummer + projektnamn (t.ex. "615002 TESTPROJEKT 1"),
// aldrig till det interna databas-id:t (#12). Det interna id:t saknar referens för användaren
// och ska aldrig visas i normalflödet — endast som tillfälligt fallback under laddning.

/**
 * Slå ihop ett projektnummer och -namn till "<nummer> <namn>".
 * Faller tillbaka på enbart namn, enbart nummer, eller null om inget finns.
 *
 * @param {string|number|null|undefined} number
 * @param {string|null|undefined} name
 * @returns {string|null}
 */
export function joinProjectLabel(number, name) {
  const n = number != null && String(number).trim() ? String(number).trim() : '';
  const nm = name != null && String(name).trim() ? String(name).trim() : '';
  if (n && nm && !nm.startsWith(n)) return `${n} ${nm}`;
  if (nm) return nm;
  if (n) return n;
  return null;
}

/**
 * Bygg en användarvänlig projektetikett från ett projektobjekt.
 * Läser number/project_number och name/project_name/title (olika moduler har olika fältnamn).
 *
 * @param {object|null|undefined} project
 * @returns {string|null} formaterad etikett, eller null om varken namn eller nummer finns
 */
export function formatProjectLabel(project) {
  if (!project) return null;
  const number = project.number != null ? project.number : project.project_number;
  const name = project.name != null ? project.name
    : (project.project_name != null ? project.project_name : project.title);
  return joinProjectLabel(number, name);
}

/**
 * Som formatProjectLabel, men med säkert fallback till "Projekt #<id>" när varken
 * namn eller nummer finns (acceptabelt under laddning — det interna id:t visas bara tillfälligt).
 *
 * @param {object|null|undefined} project
 * @param {string|number|null} [fallbackId] - används om project saknar id
 * @returns {string}
 */
export function projectLabelOrFallback(project, fallbackId) {
  const label = formatProjectLabel(project);
  if (label) return label;
  const id = fallbackId != null ? fallbackId : (project ? project.id : null);
  return id != null ? `Projekt #${id}` : 'Projekt';
}
